export const VALIDATION = {
  REQUIRED: 'Обязательное поле!',
};
